import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";

export default class ReferralAccount extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "referral-account";
    static pluralName = "referral-accounts";

    constructor() {
        super(ReferralAccount.kind, ReferralAccount.singularName, ReferralAccount.pluralName);
    }

    async getMine() {
        return this.action({}, "/referrals/me");
    }

    async redeem(data) {
        return this.postAction("/referrals/redeem", data);
    }

    async register(data) {
        return this.postAction("/referrals/register", data);
    }
}
